import '../../css/common.scss';
import './ControlPanel.scss';
import { getRequired, create, createDiv } from '../core/domMan';
import statusBarCctr, { wrapperName as statusBarWrapperId } from '../components/statusBar';
import titleBarCctr, { wrapperName as titleBarWrapperId } from '../components/titleBar';
import contentBoxCctr, { wrapperName as contentBoxWrapperId } from '../components/contentBox';
// import blackMist from '../../assets/CPHMIST_Logo_RGB_300px_Black.png';
// import whiteMist from '../../assets/CPHMIST_Logo_RGB_300px_White.png';
// import greyMist from '../../assets/CPHMIST_Logo_RGB_300px_Grey.png';

import blackMist from '../../assets/logo-black.png'
import whiteMist from '../../assets/logo-white.png'
import greyMist from '../../assets/logo-grey.png'

import styling from '../core/styling.js';
export const wrapperName = 'controlPanelWrapper';
export const identifier = 'controlPanel';
export default (owner) => {
    let result = {};
    let preudoLogoDoppenginer, mistLogo, mistLogoDark, mistLogoGrey;
    let controlPanel = result.controlPanel = document.getElementById(identifier);
    if (controlPanel) {
        Object.defineProperties(result, {
            titleBar: { value: titleBarCctr() },
            statusBar: { value: statusBarCctr() },
            contentBox: { value: contentBoxCctr() },
            customerLogo: { value: getRequired('customerLogo') },
        });

        mistLogo = getRequired('mstLogo');
        mistLogoDark = getRequired('mstLogo-dark');

        preudoLogoDoppenginer = getRequired('pseudoCustomerLogoAlignment');
    }
    else {
        owner = owner ?? getRequired(wrapperName);
        const flex = createDiv(owner, { className: 'flex' });
        controlPanel = createDiv(flex, { id: identifier });
        preudoLogoDoppenginer = create(controlPanel, 'img', { id: 'pseudoCustomerLogoAlignment', className: `logo invisible h-0` });
        const titleBarWrapper = createDiv(controlPanel, { id: titleBarWrapperId });

        const bottom = createDiv(flex, { id: 'controlPanel-bottom', className: 'w-full fixed bottom-0 left-0 flex justify-between items-end' });

        const restZone = createDiv(bottom, { className: 'w-full flex flex-wrap justify-end items-end' });
        const contentBoxWrapper = createDiv(restZone, { id: contentBoxWrapperId });
        const statusBarWrapper = createDiv(restZone, { id: statusBarWrapperId });
        const mistLogoZone = createDiv(bottom, { className: 'mstLogoWrapper' });
        mistLogo = create(mistLogoZone, 'img', { id: 'mstLogo', className: 'mstLogo logo', src: blackMist });
        mistLogoDark = create(mistLogoZone, 'img', { id: 'mstLogo-dark', className: 'mstLogo logo', src: whiteMist });
        mistLogoGrey = create(mistLogoZone, 'img', { id: 'mstLogo-grey', className: 'mstLogo logo', src: greyMist });

        Object.defineProperties(result, {
            titleBar: { value: titleBarCctr(titleBarWrapper) },
            statusBar: { value: statusBarCctr(statusBarWrapper) },
            contentBox: { value: contentBoxCctr(contentBoxWrapper) },
            controlPanel: { value: controlPanel },
            customerLogo: { value: create(controlPanel, 'img', { id: 'customerLogo', className: `logo invisible` }) },
        });

        //styling.hide(result.customerLogo);
    }

    result.setCustomerLogo = (src) => {
        if (src) {
            preudoLogoDoppenginer.src = result.customerLogo.src = src;
            result.customerLogo.classList.remove('invisible');
            styling.show(result.customerLogo);
        } 
        else if (!result.customerLogo.classList.contains('invisible')) {
            result.customerLogo.classList.add('invisible');
        }

    }

    const setMistLogo = (normal, dark) => {
        mistLogo.src = normal;
        mistLogoDark.src = dark || normal;

        styling.show([mistLogo, mistLogoDark]);
    }


    result.setMistLogo = setMistLogo;
    return result;
}